import { ActionContext } from "vuex";
import { State } from "../state";
import { LogState } from "./state";
import { getStoreAccessors } from "typesafe-vuex";
import { api } from "@/api";
import { dispatchCheckApiError } from "@/store/task/actions";
import { commitSetLogContent } from "@/store/log/mutations";

type LogContext = ActionContext<LogState, State>;

export const actions = {
  async actionGetLogContent(
    context: LogContext,
    payload: { type: string; line: number }
  ) {
    try {
      const response = await api.getLogContent(
        context.rootState.main.token,
        payload.type,
        payload.line
      );
      if (response) {
        commitSetLogContent(context, response.data);
      }
    } catch (error) {
      if (error.response.status === 403) {
        return {
          data: error.response.data.data,
          message: error.response.data.message,
        };
      }
      await dispatchCheckApiError(context, error);
    }
  },
};

const { dispatch } = getStoreAccessors<LogState, State>("");

export const dispatchGetLogContent = dispatch(actions.actionGetLogContent);
